import React, { useState } from "react";
import VerticalTabs from "shared/components/verticalTabs/VerticalTabs";
import TelaConfiguracaoCondominiosIntegradosGroupPay from "./TelaConfiguracaoCondominiosIntegradosGroupPay";
import useStyles from "./styles/AbaConfiguracoesGroupPayStyles";
import ConfigurarBuscaNFEmail from "./configurarBuscaNFEmail/ConfigurarBuscaNFEmail";

const AbaConfiguracoesGroupPay: React.FC = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const classes = useStyles();

  const tabsVericais = [
    {
      label: "Ativação e busca de NF externa",
      component: <TelaConfiguracaoCondominiosIntegradosGroupPay />,
    },
    {
      label: "Busca de NF por e-mail",
      component: <ConfigurarBuscaNFEmail isInsideWizard={false} />,
    },
  ];

  const handleTabChange = (index: number) => {
    setActiveTab(index);
  };

  return (
    <div className={classes.root}>
      <div className={classes.sidebar}>
        <VerticalTabs
          title="Configurações do Group Pay"
          tabs={tabsVericais}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />
      </div>

      <div className={classes.content}>
        {tabsVericais[activeTab].component}
      </div>
    </div>
  );
};

export default AbaConfiguracoesGroupPay;